import React from 'react'
import {  FiArrowLeft } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-primary/20 to-primary px-4 text-center font-spaceGrotesk">
      {/* <div className="max-w-md w-full py-12 px-6 bg-white rounded-lg border border-gray-700 shadow-lg"> */}
        {/* <FiAlertTriangle className="text-primary mx-auto text-7xl mb-6 animate-pulse" /> */}
        <img src={`assets/404.svg`} alt="404" className="w-[50vh] h-[50vh] mx-auto mb-6" />
        <h1 className="text-4xl font-bold text-black mb-3 font-play">404</h1>
        <h2 className="text-2xl font-semibold text-black mb-6">Page Not Found</h2>
        
        <p className="text-black mb-8">
          The page you are looking for doesn't exist or has been moved.
        </p>
        
        <button 
          onClick={() => navigate('/')}
          className="relative bg-primary text-white font-play py-3 px-6 rounded-lg hover:bg-opacity-90 transition-all duration-300 overflow-hidden group hover:scale-105 transform flex items-center gap-2 mx-auto"
        >
          <FiArrowLeft />
          <span>Back to Home</span>
          <div className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-500 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12"></div>
        </button>
      {/* </div> */}
    </div>
  )
}

export default NotFound
